<template>
    <div>
        <div style="margin-bottom: 12px">
            <div>
                <el-form inline>
                    <el-form-item style="width: 200px">
                        <el-select v-model="searchParams.nickName" placeholder="选择姓名" clearable filterable>
                            <el-option v-for="item in nickNameOptions" :key="item.id" :label="item.nickName" :value="item.nickName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width: 200px">
                        <el-select v-model="searchParams.patch" placeholder="选择批次" clearable filterable>
                            <el-option v-for="item in patchOptions" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width: 200px">
                        <el-select v-model="searchParams.platformName" placeholder="选择平台" clearable filterable>
                            <el-option v-for="item in platformNameOptions" :key="item.id" :label="item.platformName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="allorder">查询</el-button>
                        <el-button type="" @click="reset">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <span style="color: aliceblue"> </span>
            <el-table :data="nobuytotalList" :default-sort="{ prop: 'nickName', order: 'descending' }" border style="width: 100%">
                <el-table-column type="index" label="序号" width="55" align="center" header-align="center">
                    <template v-slot="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="nickName" sortable label="姓名" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="patch" sortable label="批次" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="platformName" label="平台" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="orderCount" label="总数" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="allAmount" label="总额" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="productQty" label="中标数量" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="orderAmount" label="中标金额" min-width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column label="中标率" min-width="180" align="center" header-align="center">
                    <template #default="scope">
                        {{
                            scope.row.orderCount !== 0 && scope.row.productQty && scope.row.orderCount
                                ? ((scope.row.productQty / scope.row.orderCount) * 100).toFixed(2) + "%"
                                : "暂无相关数据"
                        }}
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex; justify-content: center">
                <el-pagination
                    :current-page="currentPageDay"
                    :page-size="itemsPerPageDay"
                    :page-sizes="[20, 40, 60, 80]"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleDaySizeChange"
                    @current-change="handleDayCurrentChange"
                    :total="allitemsDay">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script setup>
    import axios from "axios";
    import { ref } from "vue";
    /* ################################## */
    /*               下拉框初始化               */
    /* ################################## */
    const nickNameOptions = ref([]);
    const patchOptions = ref([]);
    const platformNameOptions = ref([]);

    const getPatchOptions = () => {
        axios
            .get("/api/orderDetails/init", {
                headers: {
                    satoken: localStorage.sa,
                },
            })
            .then((response) => {
                patchOptions.value = response.data.data.patchList;
            });
    };
    const getPlatformNameOptions = () => {
        axios
            .get("/api/systemPlatformInfo/platForm/init", {
                headers: {
                    satoken: localStorage.sa,
                },
            })
            .then((response) => {
                platformNameOptions.value = response.data.data;
            });
    };

    const getNickNameOptions = () => {
        axios
            .get("/api/user/queryAllUser?pageNo=1&pageSize=10000", {
                headers: {
                    satoken: localStorage.sa,
                },
            })
            .then((response) => {
                nickNameOptions.value = response.data.data.result;
            });
    };

    const getSearchParamsInit = () => {
        getPatchOptions();
        getPlatformNameOptions();
        getNickNameOptions();
        allorder();
    };
    defineExpose({
        getSearchParamsInit,
    });

    /* ################################## */
    /*                 分页                 */
    /* ################################## */
    const currentPageDay = ref(1);
    const itemsPerPageDay = ref(20);

    const handleDayCurrentChange = (val) => {
        currentPageDay.value = val;
        allorder();
    };

    const handleDaySizeChange = (val) => {
        itemsPerPageDay.value = val;
        currentPageDay.value = 1;
        allorder();
    };
    /* ################################## */
    /*                查询订单                */
    /* ################################## */
    const selectanyURL = ref("/api/orderDetails/queryOrderDetailsStatisticsList");
    const allitemsDay = ref(0);
    const nobuytotalList = ref([]);
    const searchParams = ref({
        nickName: "",
        patch: "",
        platformName: "",
    });

    const allorder = () => {
        let a = localStorage.sa;
        axios
            .get(selectanyURL.value, {
                headers: {
                    satoken: a,
                },
                params: {
                    pageNo: currentPageDay.value,
                    pageSize: itemsPerPageDay.value,
                    ...searchParams.value,
                },
            })
            .then((response) => {
                nobuytotalList.value = response.data.data.result;
                allitemsDay.value = response.data.data.total;
            })
            .catch((error) => {
                console.error("获取数据出错:", error);
            });
    };
    /* ################################## */
    /*                重置按钮                */
    /* ################################## */
    const reset = () => {
        searchParams.value = {
            nickName: "",
            patch: "",
            platformName: "",
        };
    };
</script>
